var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.813 20.72v81.25L135.78 75.624l17.564 46.938-115.656-20.938 84.718 49.906H20v27.345l110.47 14.875 96.593-29.188c-11.303-11.87-18.594-30.743-18.594-52 0-35.926 20.87-65.062 46.624-65.062 25.753 0 46.625 29.136 46.625 65.063 0 20.847-7.038 39.375-17.97 51.28l99.03 29.907 112.5-15.156V151.53H394.19l84.718-49.905-120.437 21.78 17.874-47.718-48.656 29.126V20.72H179.813zM495.28 223.343l-112.5 22.437-55.405-13.124-28.03 118.313 16.592 145h51.688L329.25 351.22l46.53 27.842-21.31-56.937 124.436 22.5-91.125-53.688h107.5v-67.593zM20 223.75v67.188h108.813l-91.125 53.687L157.31 322.97 136.345 379l38.47-23-28.595 139.97h48.155L207.28 351.56 185.595 232.72l-55.125 13.06L20 223.75z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimism);
export default __webpack_public_path__ + "static/media/Animism.de981945fd691921446be1447ab372c2.svg";
export { ForwardRef as ReactComponent };